import React, { useState, useEffect } from 'react';
import './Timeline.css'; // Ensure your CSS is correctly linked

function Timeline({ events, deleteEvent, editEvent }) {
  const [editId, setEditId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editDate, setEditDate] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [expandedMonths, setExpandedMonths] = useState({}); // Track which months are expanded

  useEffect(() => {
    // By default, only expand the current month
    const currentMonthKey = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    setExpandedMonths({ [currentMonthKey]: true });
  }, []);

  const startEdit = (event) => {
    setEditId(event._id);
    setEditTitle(event.title);
    setEditDate(event.date.split('T')[0]);
    setEditDescription(event.description);
  };

  const saveEdit = () => {
    editEvent(editId, { title: editTitle, date: editDate, description: editDescription });
    setEditId(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    // Add one day to the date
    date.setDate(date.getDate() + 1);
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
  };

  const groupEvents = (events) => {
    const groups = {};
    events.forEach((event) => {
      const year = new Date(event.date).getFullYear();
      const month = new Date(event.date).toLocaleDateString('en-US', { month: 'long' });
      const key = `${month} ${year}`;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(event);
    });
    return groups;
  };

  const toggleMonth = (monthKey) => {
    setExpandedMonths((prevExpandedMonths) => ({
      ...prevExpandedMonths,
      [monthKey]: !prevExpandedMonths[monthKey],
    }));
  };

  const eventGroups = groupEvents(events);

  return (
    <div className="timeline">
      {Object.keys(eventGroups).map((group, groupIndex) => (
        <React.Fragment key={groupIndex}>
          <div
            className="timeline-group-title"
            onClick={() => toggleMonth(group)}
            style={{ cursor: 'pointer' }}
          >
            {group}
          </div>
          {expandedMonths[group] && (
            <div>
              {eventGroups[group].map((event, eventIndex) => (
                <div key={eventIndex} className="timeline-event">
                  <div className="timeline-date">{formatDate(event.date)}</div>
                  <div className="timeline-content">
                    {editId === event._id ? (
                      <div>
                        <input
                          type="text"
                          value={editTitle}
                          onChange={(e) => setEditTitle(e.target.value)}
                        />
                        <input
                          type="date"
                          value={editDate}
                          onChange={(e) => setEditDate(e.target.value)}
                        />
                        <textarea
                          className="timeline-description-input"
                          value={editDescription}
                          onChange={(e) => setEditDescription(e.target.value)}
                        ></textarea>
                        <button onClick={saveEdit}>Save</button>
                      </div>
                    ) : (
                      <div>
                        <h3>
                          {event.title}
                          <button className="edit-button" onClick={() => startEdit(event)}>✏️</button>
                          <button className="delete-button" onClick={() => deleteEvent(event._id)}>X</button>
                        </h3>
                        <p className="timeline-description">{event.description}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default Timeline;